/* Joi: search overlay (z-70) on Shopify's Predictive Search API, rendered by
   Liquid via the Section Rendering API so result rows keep their metafield
   descriptors, badges and money formatting.
   - empty query shows the server-rendered default state ("THE ISSUE — ALL
     SIX PRINTS", pre-rendered from the drop collection);
   - typing swaps in live results (220 ms debounce);
   - the archive-pointing empty state comes back Liquid-rendered too. */

class JoiSearch extends HTMLElement {
  connectedCallback() {
    if (this.dataset.joiInit) return;
    this.dataset.joiInit = 'true';
    this.input = this.querySelector('[data-joi-search-input]');
    this.results = this.querySelector('[data-joi-search-results]');
    this.defaultState = this.results ? this.results.innerHTML : '';
    this.sectionId = this.dataset.resultsSection || 'predictive-search';
    this.timer = null;
    this.controller = null;

    if (!this.input || !this.results) return;

    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.query(this.input.value.trim()), 220);
    });

    /* Joi: re-focus the input every time the overlay opens */
    document.addEventListener('joi:overlay:opened', (e) => {
      if (e.detail?.name === 'search') {
        this.input.focus({ preventScroll: true });
        this.input.select();
      }
    });
  }

  async query(term) {
    if (!term) {
      this.results.innerHTML = this.defaultState;
      return;
    }
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    try {
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '10',
        section_id: this.sectionId,
      });
      const res = await fetch(`/search/suggest?${params}`, { signal: this.controller.signal });
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-joi-search-results-inner]');
      if (fresh) this.results.innerHTML = fresh.outerHTML;
    } catch (err) {
      if (err.name !== 'AbortError') { /* keep last good state */ }
    }
  }
}

if (!customElements.get('joi-search')) customElements.define('joi-search', JoiSearch);
